module.exports = __webpack_public_path__ + "img/porcoes.a6b50457.svg";